import ValidatedGroup from "../validated-group";

export interface CheckboxResult {
    label: string;
    uri: string;
}

/**
 * Allow to validate a checkbox inputs group
 */
export default class ValidatedCheckBoxGroup extends ValidatedGroup {
    private checkboxesContainer: HTMLElement;

    constructor(props: any, element: HTMLInputElement) {
        super(props, element);

        this.checkboxesContainer = this.element.parentElement;
        this.errorMessage = document.createElement('span');
    }

    mounted(): void {
        this.initialize();
    }

    /**
     * Scan for checkbox group
     */
     initialize() : void {
        this.inputsArray = [...this.element.querySelectorAll('input[type=checkBox]')] as HTMLInputElement[];
    }

    public getInputs(): HTMLInputElement[] {
        return this.inputsArray;
    }

    displayErrors(): void {
        if (this.valid) {
            this.errorMessage.remove();
            this.inputsArray.forEach((checkbox) => {
                if (checkbox.checked) {
                    checkbox.nextElementSibling.classList.add("label-select");
                } else {
                    checkbox.nextElementSibling.classList.remove("label-select");
                }
            })
        } else {
            this.errorMessage.classList.add('error-checkbox-group');
            this.errorMessage.innerHTML = this.requiredMessage;
            this.checkboxesContainer.appendChild(this.errorMessage);
            this.inputsArray.forEach((checkbox) => {
                checkbox.nextElementSibling.classList.remove("label-select");
            })
        }
    }
    
    getValue(): CheckboxResult[] {
        const result = [];
        for (const checkbox of this.inputsArray) {
            if(checkbox.checked) {
                const newContractType = { "label": checkbox.getAttribute("data-label"), "uri": checkbox.id }
                result.push(newContractType);
            }
        }
        return result;
    }
}
